import { mergeStyles, IButtonProps, IStyle, HighContrastSelector } from 'office-ui-fabric-react';
import { buttonStylingConstants, menuStylingConstants } from './StylingConstants';

export const iconContainerStyle = mergeStyles({
  fontSize: buttonStylingConstants.buttonFontSize,
  height: 16,
  margin: '7px 0',
  width: 16
});

const getTextStyle = (props: IButtonProps): IStyle => {
  return {
    fontFamily: buttonStylingConstants.buttonFontFamily,
    fontSize: buttonStylingConstants.buttonFontSize,
    fontWeight: buttonStylingConstants.buttonFontWeight,
    color: props.disabled ? buttonStylingConstants.buttonDisabledColor : buttonStylingConstants.buttonColor
  };
};

export const getMenuButtonContainerStyle = (props: IButtonProps): string => {
  return mergeStyles(getTextStyle(props), {
    alignItems: 'stretch',
    textAlign: 'left',
    backgroundColor: props.checked
      ? buttonStylingConstants.buttonPressedBackgroundColor
      : menuStylingConstants.menuBackgroundColor,
    borderWidth: 0,
    display: 'flex',
    height: 'auto',
    outline: props.toggled ? '1px solid' : 'none',
    outlineOffset: props.toggled ? '-1px' : '0px',
    padding: '0 11px',
    width: '100%',
    selectors: {
      [HighContrastSelector]: {
        color: props.disabled ? 'grayText' : 'windowText',
        MsHighContrastAdjust: 'none',
        backgroundColor: props.disabled ? 'window' : props.checked ? 'highlight' : 'window'
      },
      ':hover': {
        backgroundColor: buttonStylingConstants.buttonHoverFocusBackgroundColor,
        selectors: {
          [HighContrastSelector]: {
            backgroundColor: props.disabled ? 'window' : 'highlight',
            color: props.disabled ? 'grayText' : 'highlightText',
            MsHighContrastAdjust: 'none'
          }
        }
      },
      ':pressed': {
        backgroundColor: buttonStylingConstants.buttonPressedBackgroundColor,
        selectors: {
          [HighContrastSelector]: {
            backgroundColor: 'highlight',
            color: props.disabled ? 'grayText' : 'highlightText',
            MsHighContrastAdjust: 'none'
          }
        }
      },
      ':focus': {
        outline: '1px solid',
        outlineOffset: '-1px',
        outlineColor: buttonStylingConstants.outlineFocusedColor,
        selectors: {
          [HighContrastSelector]: {
            backgroundColor: 'highlight',
            color: props.disabled ? 'grayText' : 'highlightText',
            MsHighContrastAdjust: 'none'
          }
        }
      }
    }
  });
};

export const menuButtonContentContainerStyle = mergeStyles({
  display: 'flex',
  height: 'auto',
  justifyContent: 'flex-start',
  width: '100%'
});

export const getLabelStyle = (props: IButtonProps, containerClass: string): string => {
  return mergeStyles(getTextStyle(props), {
    display: 'inline',
    paddingLeft: 12,
    paddingRight: 12,
    selectors: {
      [`.${containerClass}:hover &`]: {
        selectors: {
          [HighContrastSelector]: {
            color: props.disabled ? 'grayText' : 'highlightText',
            MsHighContrastAdjust: 'none'
          }
        }
      },
      [HighContrastSelector]: {
        color: props.disabled ? 'grayText' : 'windowText',
        MsHighContrastAdjust: 'none'
      }
    }
  });
};

export const shortcutTextStyle = mergeStyles({
  color: buttonStylingConstants.buttonColor,
  lineHeight: 14,
  paddingBottom: 8,
  paddingTop: 8,
  textAlign: 'right',
  width: '100%'
});
